module.exports = __webpack_public_path__ + "img/profess3.738dcdbe.png";